<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCartStore } from '../stores/cart';
import ShoppingCart from './ShoppingCart.vue';
import cartShoppingIcon from '@fortawesome/fontawesome-pro/svgs/regular/cart-shopping.svg?raw';
import { CART_POPOVER_ID } from '../constants';

const { t } = useI18n({ useScope: 'global' });
const cart = useCartStore();
</script>

<template>
    <button
        type="button"
        class="cart-button"
        :class="{ 'cart-button--has-items': (cart.cart?.totalQty ?? 0) > 0 }"
        :popovertarget="CART_POPOVER_ID"
    >
        <span class="cart-button__icon" aria-hidden="true" v-html="cartShoppingIcon" />
        <span class="visually-hidden">{{ t('cart.buttonLabel', { count: cart.cart?.totalQty ?? 0 }) }}</span>
        <span v-if="(cart.cart?.totalQty ?? 0) > 0" class="cart-button__badge" aria-hidden="true">
            {{ cart.cart?.totalQty }}
        </span>
    </button>

    <ShoppingCart />
</template>
